import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export const YMS_LIST_VIEW_IMPROVEMENTS_FLAG = 'enable-yms-list-view-improvement';

export function useYmsListViewImprovementsFeature() {
  const featureFlag = useFlag(YMS_LIST_VIEW_IMPROVEMENTS_FLAG);

  const isListViewImprovementsEnabled = computed(() => Boolean(featureFlag.value?.enabled));

  /**
   * Whether the feature flag has resolved. Used to defer rendering the improved List View surfaces
   * until the flag is known, so they do not pop in a beat after the table has already painted.
   */
  const isListViewImprovementsReady = computed(() => Boolean(featureFlag.value?.ready));

  /** Enabled and resolved — what the List View surfaces should gate on. */
  const isListViewImprovementsVisible = computed(
    () => isListViewImprovementsReady.value && isListViewImprovementsEnabled.value
  );

  return {
    isListViewImprovementsEnabled,
    isListViewImprovementsReady,
    isListViewImprovementsVisible
  };
}
